import { createContext, useContext } from "react";

import type { BrandMenuGet, BrandMenuPatch } from "@/api/admin/brands/types";
import type { BranchAvailability } from "@/components/units/DishDrawer";

import type { BrandFormMenuType, CategoryType, DishFormType } from "../types";

export enum MODE_MENU_ACTION {
  CREATE = "create",
  EDIT = "edit",
}

export interface MenuActions {
  isEnabled: boolean;
  patchMenu: (payload: BrandMenuPatch) => Promise<BrandMenuGet | void>;
  createCategory: (
    nameEn: string,
    nameAr?: string
  ) => Promise<CategoryType | void>;
  updateCategory: (
    categoryId: string,
    nameEn: string,
    nameAr?: string
  ) => Promise<void>;
  deleteCategory: (categoryId: string) => Promise<void>;
  reorderCategories: (orderedCategoryIds: string[]) => Promise<void>;
  reorderDishes: (
    categoryId: string,
    orderedDishIds: string[]
  ) => Promise<void>;
  saveDish: (
    categoryId: string,
    dish: DishFormType,
    branchAvailability: BranchAvailability[],
    mode: MODE_MENU_ACTION
  ) => Promise<DishFormType | void>;
  persistParsedMenu: (
    categories: CategoryType[]
  ) => Promise<BrandFormMenuType | void>;
  deleteDish: (categoryId: string, dishId: string) => Promise<void>;
  fetchDish: (dishId: string) => Promise<DishFormType | void>;
  updateDishActive: (dishId: string, active: boolean) => Promise<void>;
  invalidateMenuQuery: () => Promise<void>;
}

const noopAsync = async () => undefined;

export const localMenuActions: MenuActions = {
  isEnabled: false,
  patchMenu: noopAsync,
  createCategory: noopAsync,
  updateCategory: noopAsync,
  deleteCategory: noopAsync,
  reorderCategories: noopAsync,
  reorderDishes: noopAsync,
  saveDish: noopAsync,
  persistParsedMenu: noopAsync,
  deleteDish: noopAsync,
  fetchDish: noopAsync,
  updateDishActive: noopAsync,
  invalidateMenuQuery: noopAsync,
};

export const MenuActionsContext = createContext<MenuActions>(localMenuActions);

export const useMenuActions = () => useContext(MenuActionsContext);
